const ReportEndpoints = {
  deliveryDetail: "api/reports/delivery-detail",
  deliverySummary: "api/reports/delivery-summary",
  deliverySearch: "api/reports/delivery-search",
  distanceMatrix: `api/reports/distance-matrix`,
  podDeliveryReport: "api/reports/pod-delivery-report",
  deliveryReceipt: "api/reports/delivery-receipt-report",
  deliveryAreas: "api/reports/delivery-areas",
};

export { ReportEndpoints };
